import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiYoutube, FiTwitter, FiMusic, FiCamera, FiMessageCircle } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiInstagram,
      name: 'Instagram',
      description: 'Followers, Likes, Views, Comments',
      color: 'from-pink-500 to-purple-600',
      bgColor: 'bg-pink-50'
    },
    {
      icon: FiYoutube,
      name: 'YouTube',
      description: 'Views, Subscribers, Likes, Comments',
      color: 'from-red-500 to-red-600',
      bgColor: 'bg-red-50'
    },
    {
      icon: FiTwitter,
      name: 'Twitter',
      description: 'Followers, Likes, Retweets, Views',
      color: 'from-blue-400 to-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      icon: FiMusic,
      name: 'TikTok',
      description: 'Followers, Likes, Views, Shares',
      color: 'from-purple-500 to-pink-600',
      bgColor: 'bg-purple-50'
    },
    {
      icon: FiCamera,
      name: 'Snapchat',
      description: 'Followers, Views, Story Views',
      color: 'from-yellow-400 to-yellow-600',
      bgColor: 'bg-yellow-50'
    },
    {
      icon: FiMessageCircle,
      name: 'Telegram',
      description: 'Members, Views, Reactions',
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Premium Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive social media marketing solutions for all major platforms. 
            High-quality services with instant delivery and guaranteed results.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`${service.bgColor} rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border border-gray-200 group cursor-pointer`}
            >
              <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r ${service.color} rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <SafeIcon icon={service.icon} className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{service.name}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-500">Starting from</span>
                <span className="text-2xl font-bold text-gray-900">$0.99</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;